


































import { Component, Prop, Vue } from 'vue-property-decorator';
import SelectorMessage from '@/models/selectorMessage';
import SelectorMessageItem from '@/components/SelectorMessageItem.vue';

@Component({
  components: {SelectorMessageItem}
})
export default class SelectorMessageList extends Vue {
  @Prop({type: Array, required: true}) selectorMessages!: SelectorMessage[];
}
